module.exports = __webpack_public_path__ + "static/media/baloto.64de9222.png";